import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/** 분리앱(예약 창) 자체의 상태 — 일렉트론이 IPC 로 채운다 */
export type SaaSState = {
    isWindow: boolean
    locale: string
    timezone: string
}

const state: SaaSState = {
    isWindow: false,
    locale: '',
    timezone: '',
}

type Store = { commit(type: string, payload: unknown): void }

const actions = {
    'AC_SetIsWindow': (store: Store, isWindow: boolean): void => {
        store.commit('MU_SetIsWindow', isWindow)
    },
}

const mutations = {
    'MU_SetIsWindow': (state: SaaSState, isWindow: boolean): void => {
        state.isWindow = isWindow
    },
    'MU_SetLocale': (state: SaaSState, locale: string): void => {
        state.locale = locale
    },
    'MU_SetTimezone': (state: SaaSState, timezone: string): void => {
        state.timezone = timezone
    },
}

const SaaS: Module<SaaSState, StoreState> = { state, actions, mutations }

export default SaaS
